// extracted by mini-css-extract-plugin
export default {"editor-wrapper":"editor_editor-wrapper__PPvhr"};